var fn = function( obj ){
var __t,__p='';
__p+='\nuniform sampler2D tChromaShiftTex;\n\nuniform float uAmount;';
return __p;
};
fn.toString=fn;
module.exports = fn;